module.exports = __webpack_public_path__ + "img/c3.2006e6be.webp";